import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnersModule } from './partners/partners.module';

@NgModule({
  imports: [CommonModule],
  exports: [
    PartnersModule,
  ],
})
export class GraphqlModule {}
